import React from "react";
import {FlexS} from "./styles";


 const Flex = ({
                         children,
                         direction = "row wrap",
                         jc ="center",
                         alg="center",
                         elastic="0 0 auto",
                         className,style
                     })=>{

    let bpoints  = {
        direction:{
            xs: direction[0],
            sm: direction[1],
            md: direction[2],
            lg: direction[3],
            xl: direction[4],
        },
        jc:{
            xs: jc[0],
            sm: jc[1],
            md: jc[2],
            lg: jc[3],
            xl: jc[4],
        },
        alg:{
            xs: alg[0],
            sm: alg[1],
            md: alg[2],
            lg: alg[3],
            xl: alg[4],
        },
        flex:{
            xs: elastic[0],
            sm: elastic[1],
            md: elastic[2],
            lg: elastic[3],
            xl: elastic[4],
        }
    };

    let theme = {
        direction:   typeof direction  !== "string" ? bpoints["direction"] : {xs:direction},
        jc:          typeof jc         !== "string" ? bpoints["jc"]        : {xs:jc},
        alg:         typeof alg        !== "string" ? bpoints["alg"]       : {xs:alg},
        elastic:     typeof elastic    !== "string" ? bpoints.flex         : {xs:elastic},
    };

    return(
        <FlexS
            className={className}
            theme={theme}
            style={style}
        >
            {children}
        </FlexS>
    )
};
 export default Flex;
